import React from 'react';
import PropTypes from 'prop-types';

import SelectionToggle from '../Shared/UI/SelectionToggle/';

const DriversTable = props => (
  <div className="table-responsive">
    <table className="table-long">
      <thead>
        <tr>
          <th>
            <SelectionToggle
              allCount={props.allCount}
              selectedCount={props.selectedCount}
              onToggleSelection={props.onToggleSelection}
            />
          </th>
          <th>Nome</th>
          <th>Residência</th>
          <th>Dias Trabalhados</th>
          <th>Evento Atual</th>
          <th>Próximo Evento</th>
          <th>Eventos</th>
          <th />
        </tr>
      </thead>
      <tbody>
        {props.children}
      </tbody>
    </table>
  </div>
);

DriversTable.propTypes = {
  children: PropTypes.node.isRequired,
  allCount: PropTypes.number.isRequired,
  selectedCount: PropTypes.number.isRequired,
  onToggleSelection: PropTypes.func.isRequired,
};

export default DriversTable;



// WEBPACK FOOTER //
// ./src/Driver/DriversTable.js